interface SuffixShipping {
  freeShipping: boolean;
}

interface SuffixPrice {
  displayprice: string;
  mapprice: string;
  maptype: string;
  onsale: string;
  p1price: string;
  qtydiscountlots: string;
  qtydiscountprices: string;
  qtydiscountqtys: string;
  stockflag: string;
  min_buy: string;
  must_buy: string;
  returnable: string;
  unavailable: string;
  hasRequiredAccessory: boolean;
  uom: string;
  p5: string;
  isInstallServiceEligible: boolean;
  showQtyDiscountRibbon: boolean;
  drop_down_select: string;
  isPlatinumPlusExclusive: boolean;
  customerIsPlatinumOrPlus: boolean;
}

interface SuffixPriceObject {
  [key: string]: SuffixPrice;
}

interface SuffixShippingObject {
  [key: string]: SuffixShipping;
}

declare global {
  interface Window {
    suffixShippingObj: SuffixShippingObject;
    suffixPriceObj: SuffixPriceObject;
  }
}

interface ItemNumber {
  toString: () => string;
}

export default class Suffix {
  static lookup(
    itemNumber: ItemNumber,
    suffixObject?: SuffixShippingObject | SuffixPriceObject,
  ): SuffixShipping | SuffixPrice | Record<string, unknown> {
    if (!suffixObject) return {};

    const item = suffixObject[itemNumber.toString()];
    const noSelection = document.querySelector(".form--suffix .no-selection");

    if (!item) return {};

    if (!noSelection) return item;

    noSelection.classList.remove("no-selection");

    return item;
  }

  static priceLookup(itemNumber: string) {
    const { suffixPriceObj } = window;

    return Suffix.lookup(itemNumber, suffixPriceObj) as SuffixPrice;
  }

  static shippingLookup(itemNumber: ItemNumber) {
    const { suffixShippingObj } = window;

    return Suffix.lookup(itemNumber, suffixShippingObj);
  }
}
